import e from"./SearchInput.vue_vue&type=script&lang.js";import{render as t}from"./SearchInput.vue_vue&type=template&id=00f0f603&lang.js";e.render=t;export default e;
//# sourceMappingURL=SearchInput.vue.js.map
